@use "../../styles/breakpoints";

// Should be kept in sync with the tsx sizes object
$image-size-xs: 42px;
$image-size-sm: 72px;
$image-size-md: 108px;
$image-size-lg: 132px;
$image-size-xl: 192px;
$image-size-xxl: 246px;

@mixin icon-100 {
  hp6-icon {
    width: 100%;
    height: 100%;
  }
}

@mixin image-dimensions-xs {
  height: $image-size-xs;
  width: $image-size-xs;
  @include icon-100;
}

@mixin image-dimensions-sm {
  height: $image-size-sm;
  width: $image-size-sm;
  @include icon-100;
}

@mixin image-dimensions-md {
  height: $image-size-md;
  width: $image-size-md;
  @include icon-100;
}

@mixin image-dimensions-lg {
  height: $image-size-lg;
  width: $image-size-lg;
  @include icon-100;
}

@mixin image-dimensions-xl {
  height: $image-size-xl;
  width: $image-size-xl;
  @include icon-100;
}

@mixin image-dimensions-xxl {
  height: $image-size-xxl;
  width: $image-size-xxl;
  @include icon-100;
}

:host {
  display: block;
  flex-shrink: 0;
  border: solid 1px var(--color-neutral-light);
  border-radius: 50%;
  padding: 5px;

  hp6-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: var(--color-neutral-xlight);
    fill: var(--color-neutral-base);
  }

  .image-container {
    border-radius: 50%;
    overflow: hidden;
    width: 100%;
    height: 100%;

    img {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: auto;
      background-color: transparent;
      background-position: center;
      background-size: contain;
    }
  }
}

:host(.size-xs-xs) {
  @include image-dimensions-xs;
}

:host(.size-xs-sm) {
  @include image-dimensions-sm;
}

:host(.size-xs-md) {
  @include image-dimensions-md;
}

:host(.size-xs-lg) {
  @include image-dimensions-lg;
}

:host(.size-xs-xl) {
  @include image-dimensions-xl;
}

:host(.size-xs-xxl) {
  @include image-dimensions-xxl;
}

@include breakpoints.small-up {
  :host(.size-sm-xs) {
    @include image-dimensions-xs;
  }

  :host(.size-sm-sm) {
    @include image-dimensions-sm;
  }

  :host(.size-sm-md) {
    @include image-dimensions-md;
  }

  :host(.size-sm-lg) {
    @include image-dimensions-lg;
  }

  :host(.size-sm-xl) {
    @include image-dimensions-xl;
  }

  :host(.size-sm-xxl) {
    @include image-dimensions-xxl;
  }
}

@include breakpoints.medium-up {
  :host(.size-md-xs) {
    @include image-dimensions-xs;
  }

  :host(.size-md-sm) {
    @include image-dimensions-sm;
  }

  :host(.size-md-md) {
    @include image-dimensions-md;
  }

  :host(.size-md-lg) {
    @include image-dimensions-lg;
  }

  :host(.size-md-xl) {
    @include image-dimensions-xl;
  }

  :host(.size-md-xxl) {
    @include image-dimensions-xxl;
  }
}

@include breakpoints.large {
  :host(.size-lg-xs) {
    @include image-dimensions-xs;
  }

  :host(.size-lg-sm) {
    @include image-dimensions-sm;
  }

  :host(.size-lg-md) {
    @include image-dimensions-md;
  }

  :host(.size-lg-lg) {
    @include image-dimensions-lg;
  }

  :host(.size-lg-xl) {
    @include image-dimensions-xl;
  }

  :host(.size-lg-xxl) {
    @include image-dimensions-xxl;
  }
}
